import React from "react";
import { useQuery } from "react-query";

import { getAllEmlakjetProperties } from "../utils/api";

const useEmlakjetProperties = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    "allProperties",
    getAllEmlakjetProperties,
    { refetchOnWindowFocus: false }
  );

  return {
    data,
    isError,
    isLoading,
    refetch,
  };
};

export default useEmlakjetProperties;
